/*
 * SundAir2019Plugin.js
 *
 * Description: This is our plugin object. It can be exported to be used anywhere.
 *
 * This file is part of: "http://apps.sundair.com/", "Sundair-2019"
 * Copyright 2018,2019,2020 Sundair GmbH
 * Contact:  http://www.sundair.com/
 * @author Learek <michael.broeker@sundair.com>
 *
 */
const SundAir2019Plugin = {
	// The install method is all that needs to exist on the plugin object.
	// It takes the global Vue object as well as user-defined options.
	install(Vue, options) {

		/***********************************************************************
        *
        * Desc:
        * Note:
        */
		// We call Vue.mixin() here to inject functionality into all components.
		// Vue.mixin({
		//     // Anything added to a mixin will be injected into all components.
		//     // In this case, the mounted() method runs when the component is added to the DOM.
		//     mounted() {
		//         console.log('Mounted!');
		//     },
		// });
		Vue.loader = '';
		// Vue.myAddedMethod = function() {
		//     return Vue.myAddedProperty;
		// };


		/***********************************************************************
        *
        * Desc:
        * Note:
        *
        */
		// Add $surname instance property directly to Vue components
		// Vue.prototype.$surname = 'Broeker';
		// Vue.prototype.$myAddedMethod = function() {
		//     return Vue.prototype.$surname;
		// };


		/***********************************************************************
        * Global: make_basic_auth()
        *
        * Desc: Build 'Authorization' Key for API Calls.
        * Note:
        *
        */
		Vue.prototype.$make_basic_auth = function() {

			var me = this,
				Base64 = {},
				token,
				hash,
				user = 'booking_website',
				password = 'D1sq3ccfwests!';


			Base64 = {
				// private property
				keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',

				// public method for encoding
				encode: function(input) {
					var output = '',
						chr1,
						chr2,
						chr3,
						enc1,
						enc2,
						enc3,
						enc4,
						i = 0;

					input = Base64.utf8_encode(input);

					while (i < input.length) {
						chr1 = input.charCodeAt(i++);
						chr2 = input.charCodeAt(i++);
						chr3 = input.charCodeAt(i++);

						enc1 = chr1 >> 2;
						enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
						enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
						enc4 = chr3 & 63;

						if (isNaN(chr2)) {
							enc3 = enc4 = 64;
						} else if (isNaN(chr3)) {
							enc4 = 64;
						}

						output =
							output +
							this.keyStr.charAt(enc1) +
							this.keyStr.charAt(enc2) +
							this.keyStr.charAt(enc3) +
							this.keyStr.charAt(enc4);
					}

					return output;
				},
				// private method for UTF-8 encoding
				utf8_encode: function(string) {
					var utftext = '',
						n,
						c;

					string = string.replace(/\r\n/g, '\n');

					for (n = 0; n < string.length; n++) {
						c = string.charCodeAt(n);

						if (c < 128) {
							utftext += String.fromCharCode(c);
						} else if (c > 127 && c < 2048) {
							utftext += String.fromCharCode((c >> 6) | 192);
							utftext += String.fromCharCode((c & 63) | 128);
						} else {
							utftext += String.fromCharCode((c >> 12) | 224);
							utftext += String.fromCharCode(((c >> 6) & 63) | 128);
							utftext += String.fromCharCode((c & 63) | 128);
						}
					}

					return utftext;
				}
			};

			token = user + ':' + password;
			hash = Base64.encode(token);

			return 'Basic ' + hash;

		}; // eo function make_basic_auth()


		/***********************************************************************
        * Global: header_language()
        *
        * Desc: Right Header Language to send.
        * Note:
        *
        */
		Vue.prototype.$header_language = function() {

			var lang = 'DE',
				localStorageLanguage = JSON.parse(localStorage.getItem('sdr__lang')); // catch


			// Language in localStrage?
			if (localStorageLanguage !== null) {
				lang = localStorageLanguage.value.toUpperCase();
			}

			return lang;

		}; // eo function header_language()


		/***********************************************************************
        * Global: selectInits()
        *
        * Desc: Initializes Select Fields.
        * Note:
        *
        */
		Vue.prototype.$selectInits = function(modulo, currentLocale) {


			if (modulo === 'booking') {
				tjq('.selector select').each(function() {
					var obj = tjq(this);
					if (obj.parent().children('.custom-select').length < 1) {
						obj.after("<span class='custom-select'>" + obj.children('option:selected').html() + '</span>');

						if (obj.hasClass('white-bg')) {
							obj.next('span.custom-select').addClass('white-bg');
						}
						if (obj.hasClass('full-width')) {
							//obj.removeClass("full-width");
							//obj.css("width", obj.parent().width() + "px");
							//obj.next("span.custom-select").css("width", obj.parent().width() + "px");
							obj.next('span.custom-select').addClass('full-width');
						}
					}
				});
				tjq('body').on('change', '.selector select', function() {
					if (tjq(this).next('span.custom-select').length > 0) {
						tjq(this).next('span.custom-select').text(tjq(this).find('option:selected').text());
					}
				});
				tjq('body').on('keydown', '.selector select', function() {
					if (tjq(this).next('span.custom-select').length > 0) {
						tjq(this).next('span.custom-select').text(tjq(this).find('option:selected').text());
					}
				});
			}

			if (modulo === 'services') {
				tjq('.selector select').each(function() {
					var obj = tjq(this);
					if (obj.parent().children('.custom-select-services').length < 1) {
						obj.after(
							"<span class='custom-select-services'>" + obj.children('option:selected').html() + '</span>'
						);

						if (obj.hasClass('white-bg')) {
							obj.next('span.custom-select-services').addClass('white-bg');
						}
						if (obj.hasClass('full-width')) {
							//obj.removeClass("full-width");
							//obj.css("width", obj.parent().width() + "px");
							//obj.next("span.custom-select").css("width", obj.parent().width() + "px");
							obj.next('span.custom-select-services').addClass('full-width');
						}
					}
				});
				tjq('body').on('change', '.selector select', function() {
					if (tjq(this).next('span.custom-select-services').length > 0) {
						tjq(this).next('span.custom-select-services').text(tjq(this).find('option:selected').text());
					}
				});
				tjq('body').on('keydown', '.selector select', function() {
					if (tjq(this).next('span.custom-select-services').length > 0) {
						tjq(this).next('span.custom-select-services').text(tjq(this).find('option:selected').text());
					}
				});
			}

			if (modulo === 'rebooking') {
				tjq('.selector select').each(function() {
					var obj = tjq(this);
					if (obj.parent().children('.custom-select-rebooking').length < 1) {
						obj.after(
							"<span class='custom-select-rebooking'>" + obj.children('option:selected').html() + '</span>'
						);

						if (obj.hasClass('white-bg')) {
							obj.next('span.custom-select-rebooking').addClass('white-bg');
						}
						if (obj.hasClass('full-width')) {
							//obj.removeClass("full-width");
							//obj.css("width", obj.parent().width() + "px");
							//obj.next("span.custom-select").css("width", obj.parent().width() + "px");
							obj.next('span.custom-select-rebooking').addClass('full-width');
						}
					}
				});
				tjq('body').on('change', '.selector select', function() {
					if (tjq(this).next('span.custom-select-rebooking').length > 0) {
						tjq(this).next('span.custom-select-rebooking').text(tjq(this).find('option:selected').text());
					}
				});
				tjq('body').on('keydown', '.selector select', function() {
					if (tjq(this).next('span.custom-select-rebooking').length > 0) {
						tjq(this).next('span.custom-select-rebooking').text(tjq(this).find('option:selected').text());
					}
				});
			}


			// change UI of file input
			tjq('.fileinput input[type=file]').each(function() {
				var obj = tjq(this);
				if (obj.parent().children('.custom-fileinput').length < 1) {
					obj.after('<input type="text" class="custom-fileinput" />');
					if (typeof obj.data('placeholder') != 'undefined') {
						obj.next('.custom-fileinput').attr('placeholder', obj.data('placeholder'));
					}
					if (typeof obj.prop('class') != 'undefined') {
						obj.next('.custom-fileinput').addClass(obj.prop('class'));
					}
					obj.parent().css('line-height', obj.outerHeight() + 'px');
				}
			});

			tjq('.fileinput input[type=file]').on('change', function() {
				var fileName = this.value;
				var slashIndex = fileName.lastIndexOf('\\');
				if (slashIndex == -1) {
					slashIndex = fileName.lastIndexOf('/');
				}
				if (slashIndex != -1) {
					fileName = fileName.substring(slashIndex + 1);
				}
				tjq(this).next('.custom-fileinput').val(fileName);
			});
			// checkbox
			tjq(".checkbox input[type='checkbox'], .radio input[type='radio']").each(function() {
				if (tjq(this).is(':checked')) {
					tjq(this).closest('.checkbox').addClass('checked');
					tjq(this).closest('.radio').addClass('checked');
				}
			});
			tjq(".checkbox input[type='checkbox']").bind('change', function() {
				if (tjq(this).is(':checked')) {
					tjq(this).closest('.checkbox').addClass('checked');
				} else {
					tjq(this).closest('.checkbox').removeClass('checked');
				}
			});
			//radio
			tjq(".radio input[type='radio']").bind('change', function(event, ui) {
				if (tjq(this).is(':checked')) {
					var name = tjq(this).prop('name');
					if (typeof name != 'undefined') {
						tjq(".radio input[name='" + name + "']").closest('.radio').removeClass('checked');
					}
					tjq(this).closest('.radio').addClass('checked');
				}
			});

			// datepicker
			tjq('.datepicker-wrap input').each(function() {
				var minDate = tjq(this).data('min-date'),
					regional = '',
					dayNamesMin = [],
					monthNames = [];

				if (typeof minDate == 'undefined') {
					minDate = 0;
				}
				if (currentLocale === 'de') {
					regional = 'de';
					dayNamesMin = [ 'So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa' ];
					monthNames = [
						'Januar',
						'Februar',
						'März',
						'April',
						'Mai',
						'Juni',
						'Juli',
						'August',
						'September',
						'Oktober',
						'November',
						'Dezember'
					];
				}
				if (currentLocale === 'en') {
					regional = '';
					dayNamesMin = [ 'S', 'M', 'T', 'W', 'T', 'F', 'S' ];
					monthNames = [
						'January',
						'February',
						'March',
						'April',
						'May',
						'June',
						'July',
						'August',
						'September',
						'October',
						'November',
						'December'
					];
				}

				tjq(this).datepicker({
					firstDay: 1, // starting on 'Monday'
					regional: regional, // Leave ot empty for 'en'
					showOn: 'button',
					buttonImage: '../res/images/icon/blank.png',
					buttonText: '',
					buttonImageOnly: true,
					changeYear: false,
					/*showOtherMonths: true,*/
					minDate: minDate,
					dateFormat: 'dd.mm.yy',
					dayNamesMin: dayNamesMin,
					monthNames: monthNames,
					beforeShow: function(input, inst) {
						var themeClass = tjq(input).parent().attr('class').replace('datepicker-wrap', '');
						tjq('#ui-datepicker-div').attr('class', '');
						tjq('#ui-datepicker-div').addClass(
							'ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'
						);
						tjq('#ui-datepicker-div').addClass(themeClass);
					},
					onClose: function(selectedDate) {
						if (tjq(this).attr('name') == 'date_from') {
							if (tjq(this).closest('form').find('input[name="date_to"]').length > 0) {
								tjq(this)
									.closest('form')
									.find('input[name="date_to"]')
									.datepicker('option', 'minDate', selectedDate);
							}
						}
						if (tjq(this).attr('name') == 'date_to') {
							if (tjq(this).closest('form').find('input[name="date_from"]').length > 0) {
								tjq(this)
									.closest('form')
									.find('input[name="date_from"]')
									.datepicker('option', 'maxDate', selectedDate);
							}
						}
					}
				});
			});

		}; // eo funtion selectInits()


		/***********************************************************************
        * Global: vp_m()
        *
        * Desc: Mask Viewport.
        * Note: Loader Config here.
        *
        */
		Vue.prototype.$vp_m = function() {

			Vue.loader = this.$loading.show({
				// container: this.$refs.loadingContainer, // ?
				canCancel: false, // default false
				color: '#f5bc3a',
				loader: 'spinner',
				width: 64,
				height: 64,
				backgroundColor: '#ffffff',
				opacity: 0.5
			});

		}; // eo function vp_m()


		/***********************************************************************
        * Global: vp_m()
        *
        * Desc: Unmask Viewport.
        * Note:
        *
        */
		Vue.prototype.$vp_um = function() {

			Vue.loader.hide();

		}; // eo function vp_um()


		/***********************************************************************
        * Global: trnsl_error_message()
        *
        * Desc:
        * Note: Very incomplete!!!
        *
        * @param {String} m (Message to log)
        */
		Vue.prototype.$trnsl_error_message = function(m) {

			let me = this,
				nsa = '', // new string a
				nsb = '', // new string b
				splittedMessage = [],
				trsnltd = [],
				currentLocale = 'de',
				localStorageLanguage = JSON.parse(localStorage.getItem('sdr__lang')), // catch
				errors = [
					{ key: '20111', de: 'Ungültige Erwachsenenzahl. Geburtstag überprüfen.', en: 'Invalid number of Adults. Please check Birthdate.' }, // 'validatePassenger'
					{ key: '50055', de: 'Pax Vorname ist obligatorisch.', en: 'Pax firstname is mandatory.' }, // 'validatePassenger'
					{ key: '50056', de: 'Pax Nachname ist obligatorisch.', en: 'Pax lastname is mandatory.' }, // 'validatePassenger'
					{ key: '50015', de: 'Ihre gewünschten Services sind auf dem Flug nicht mehr vorhanden. Bitte kontaktieren Sie unseren Kundenservice.', en: 'The services you have chosen are not available anymore on the flights. Please contact our customer service.' }, // 'validatePassenger'
					{ key: '1003',  de: 'Agentur kann nicht angemeldet werden.', en: 'Agency cannot be registered.' }, // 'getAgency'
					{ key: '120102', de: 'Keine Serviceverfügbarkeit auf dem Flug für Umbuchungen.', en: 'No service availability on flight for rebooking.' }, // 'rebooking, missing services'
					{ key: '30001', de: 'Leider konnten wir Ihren Buchungscode nicht finden.', en: 'Unfortunately we could not find your Bookingcode.' }, // 'rebooking, no not found'
				];


			// Language in localStrage?
			if (localStorageLanguage !== null) {
				currentLocale = localStorageLanguage.value;
			}

			nsa = m.substring(1); // del 1st
			nsb = nsa.substr(0, nsa.length - 1); // del last
			splittedMessage = nsb.split(']['); // split
			trsnltd = errors.find((item) => item.key === splittedMessage[0]); // find


			return trsnltd[currentLocale];

		}; // eo  function trnsl_error_message()


		/***********************************************************************
        * Global: toc()
        *
        * Desc: Application Infos while Debugging.
        * Note:
        *
        * @param {String} m (Message to log)
        */
		Vue.prototype.$toc = function(m) {

			var rm = 'PROD';


			if (rm === 'DEV') {
				console.log(m);
			}

		}; // eo function toc()

	} // eo install
};

export default SundAir2019Plugin;



// WEBPACK FOOTER //
// ./src/plugins/sundair2019-plugin.js